import React, { useState, useEffect } from "react";
import {
  Container,
  MobileStepper,
  Button,
  Paper,
  Typography,
  Grid,
  SvgIcon,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import WarningIcon from "@material-ui/icons/Warning";
import DialogCrop from "../../DialogCrop/DialogCrop";
import DialogTrips from "../../Dialog/Dialog";
import CustomDialog from "../../CustomDialog/CustomDialog";
import Pdf from "../../Pdf/Pdf";
import Alert from "../../Alert/Alert";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import { ReactComponent as QRCode } from "../../../images/qr-code.svg";
import { ReactComponent as GoogleMaps } from "../../../images/google-maps.svg";
import moment from "moment-timezone";
import iphone_photo_rotation_adjust from "../../../utils/CustomRotation";
import { fetchRequest, reset } from "../../../redux/actions/fetch/fetchActions";
import { useSelector, useDispatch } from "react-redux";
import "./loads.css";
import { text } from "../../../utils/Multilanguage";
import { useStyle } from "./useStyle";
import config from "../../../config";
import getCurrentPositionAsync from '../../../utils/Geolocation';

export default function Loads(props) {
  const { data, step, setErrorResponse } = props;
  const dispatch = useDispatch();
  const fetch = useSelector((state) => state.fetch);
  const classes = useStyle();
  const [activeStep, setActiveStep] = useState(step);
  const [typeload, setTypeLoad] = useState(1);
  const [errorSnackbar, setErrorSnackbar] = useState({
    isOpen: false,
    message: "Error",
  });
  const [isOpen, setIsOpen] = useState(false);
  const [imageDataUrl, setImageDataUrl] = useState(null);
  const [openQuestionDialog, setOpenQuestionDialog] = useState(false);
  const [pdfDialog, setPdfDialog] = useState(false);
  const [pdfName, setPdfName] = useState("");

  useEffect(() => {
    setActiveStep(+localStorage.getItem("STEP"));
  }, [data]);

  const handleClosePdfDialog = () => {
    setPdfDialog(false);
  };

  const redirectToMap = (type, data) => {
    var lat = type === 1 ? data.locationFromLatitude : data.locationToLatitude;
    var lng = type === 1 ? data.locationFromLongitude : data.locationToLongitude;

    if (('standalone' in window.navigator) && window.navigator.standalone) {
      var win = window.open("https://maps.google.com/?q=" + lat + "," + lng + "", '_top');
      win.focus();
    } else {
      var win = window.open("https://maps.google.com/?q=" + lat + "," + lng + "", '_blank');
      win.focus();
    }
  };

  const onCloseDestinationWrong = () => {
    setOpenQuestionDialog(false);
  };

  const onTtime_in = async (tipo) => {
    let dataSend = null;
    const { latitude, longitude } = await getCurrentPositionAsync();

    if (tipo === 1) {
      if (data[activeStep].shipperIn === null) {
        dataSend = {
          tripId: data[activeStep].id,
          checkIn: moment.tz(new Date(), "America/Chicago").format("YYYY-MM-DD HH:mm:ss"),
          type: "SHIPPER",
          lat: latitude,
          lng: longitude
        };
      }
    } else if (tipo === 2) {
      if (data[activeStep].consigneeIn === null && data[activeStep].shipperOut !== null) {
        dataSend = {
          tripId: data[activeStep].id,
          checkIn: moment.tz(new Date(), "America/Chicago").format("YYYY-MM-DD HH:mm:ss"),
          type: "CONSIGNEE",
          lat: latitude,
          lng: longitude
        };
      } else {
        setErrorSnackbar({
          message: "Must enter PU Out first!",
          isOpen: true,
        });
      }
    } else {
      if (data[activeStep].shipperOut === null && data[activeStep].shipperIn !== null) {
        dataSend = {
          tripId: data[activeStep].id,
          checkIn: moment.tz(new Date(), "America/Chicago").format("YYYY-MM-DD HH:mm:ss"),
          type: "SHIPPER_OUT",
          lat: latitude,
          lng: longitude
        };
      } else {
        setErrorSnackbar({
          message: "Must enter PU In first!",
          isOpen: true,
        });
      }
    }

    if (dataSend !== null) {
      var token = localStorage.getItem("token");
      var authKey = localStorage.getItem("key");

      dispatch(
        fetchRequest(
          `${config.API_URL}services/app/Trip/UpdateCheckIn?key=${authKey}`,
          dataSend,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "Abp.Tenantid": config.TENANT_ID
            },
          },
          "POST"
        )
      );
    }
  };

  if (data) {
    if (data.length > 0) {
      const maxSteps = data.length;

      const handleNext = () => {
        localStorage.setItem("STEP", activeStep + 1);
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      };

      const handleBack = () => {
        localStorage.setItem("STEP", activeStep - 1);
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
      };

      const handleClose = (event, reason) => {
        if (reason === "timeout") {
          setErrorSnackbar({ ...errorSnackbar, isOpen: false });
        }
      };

      const handleTicketpickup = (type) => {
        dispatch(reset());
        if (data[activeStep].locationToUrlFile !== null) {
          setPdfName(data[activeStep].locationToUrlFile);
          setPdfDialog(true);
        } else {
          if (data[activeStep].consigneeIn === null) {
            setErrorSnackbar({
              message: "Must enter DEL In first!",
              isOpen: true,
            });
          } else {
            setTypeLoad(type);
            document.getElementById("icon-button-file").click();
          }
        }
      };

      const onFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
          const file = e.target.files[0];
          iphone_photo_rotation_adjust(file).then((result) => {
            setImageDataUrl(result);
            setIsOpen(true);
          });
        }
      };

      const handleCloseDialog = () => {
        setIsOpen(false);
        setImageDataUrl(null);
      };

      if (activeStep > data.length) {
        return "";
      } else {
        const tripData = data[activeStep];

        return (
          <div className="loads_contenedor">
            <div className={classes.root}>
              <LoadingSpinner isLoading={fetch.loading} />

              {/* Stepper navigation */}
              <MobileStepper
                steps={maxSteps}
                position='static'
                variant='text'
                activeStep={activeStep}
                style={{
                  borderRadius: 12,
                  backgroundColor: "transparent",
                  padding: "8px 0",
                }}
                nextButton={
                  <Button
                    size='medium'
                    onClick={handleNext}
                    disabled={activeStep === maxSteps - 1}
                    style={{ minHeight: 48, minWidth: 48 }}
                  >
                    <ArrowForwardIcon />
                  </Button>
                }
                backButton={
                  <Button
                    size='medium'
                    onClick={handleBack}
                    disabled={activeStep === 0}
                    style={{ minHeight: 48, minWidth: 48 }}
                  >
                    <ArrowBackIcon />
                  </Button>
                }
              />

              {/* Trip header */}
              <div style={{
                textAlign: "center",
                padding: "12px 8px",
                marginBottom: 8,
              }}>
                <Typography variant='h5' style={{ fontWeight: 700, fontSize: "1.3rem" }}>
                  {text("Trip")} #{activeStep + 1}
                </Typography>
                <Typography variant='subtitle1' style={{ color: "var(--color-text-secondary)", marginTop: 4 }}>
                  {tripData.material}
                </Typography>
                <Typography variant='body2' style={{ color: "var(--color-text-secondary)" }}>
                  Pickup Under: {tripData.pickUpUnder}
                </Typography>
                {tripData.isEmpty && (
                  <Typography variant='body2' style={{ color: "var(--color-text-secondary)" }} >
                    EMPTY
                  </Typography>
                )}

                {tripData.rejected && (
                  <Typography variant='body1' style={{
                    color: "var(--color-danger)",
                    fontWeight: 700,
                    marginTop: 4,
                    padding: "4px 12px",
                    backgroundColor: "#ffeaea",
                    borderRadius: 8,
                    display: "inline-block",
                  }}>
                    Trip Rejected
                  </Typography>
                )}
              </div>

              <Grid container spacing={1}>
                {/* Pickup location */}
                <Grid item xs={6}>
                  <Paper className={tripData.pickup_address_wrong === "1" ? classes.headerpickupWrong : classes.headerpickup} elevation={0}>
                    {tripData.pickup_address_wrong === "1" && (
                      <WarningIcon style={{ color: "#ffb300", marginRight: 4 }} />
                    )}
                    <Typography variant='body2' style={{ fontWeight: 600 }}>
                      {tripData.locationFromName}
                    </Typography>
                  </Paper>
                  <Paper className={classes.headerpickup} elevation={0} style={{ marginTop: 4 }}>
                    <Typography variant='body2'>
                      {tripData.locationFromAddress}
                    </Typography>
                  </Paper>
                  <Paper
                    className={classes.headerpickup}
                    elevation={0}
                    style={{ marginTop: 4, cursor: "pointer" }}
                    onClick={() => redirectToMap(1, tripData)}
                  >
                    <Typography variant='body2'>
                      {tripData.locationFromCode}
                      <br />
                      <SvgIcon component={GoogleMaps} style={{ marginTop: 4 }} />
                    </Typography>
                  </Paper>
                </Grid>

                {/* Delivery location */}
                <Grid item xs={6}>
                  <Paper className={tripData.delivery_address_wrong === "1" ? classes.headerpickupWrong : classes.headerdelivery} elevation={0}>
                    {tripData.delivery_address_wrong === "1" && (
                      <WarningIcon style={{ color: "#ffb300", marginRight: 4 }} />
                    )}
                    <Typography variant='body2' style={{ fontWeight: 600 }}>
                      {tripData.locationToName}
                    </Typography>
                  </Paper>
                  <Paper className={classes.headerdelivery} elevation={0} style={{ marginTop: 4 }}>
                    <Typography variant='body2'>
                      {tripData.locationToAddress}
                    </Typography>
                  </Paper>
                  <Paper
                    className={classes.headerdelivery}
                    elevation={0}
                    style={{ marginTop: 4, cursor: "pointer" }}
                    onClick={() => redirectToMap(2, tripData)}
                  >
                    <Typography variant='body2'>
                      {tripData.locationToCode}
                      <br />
                      <SvgIcon component={GoogleMaps} style={{ marginTop: 4 }} />
                    </Typography>
                  </Paper>
                </Grid>

                {/* Notes */}
                <Grid item xs={12}>
                  {tripData.notes !== "" && (
                    <Paper style={{
                      backgroundColor: "#fff9c4",
                      borderRadius: 8,
                      padding: "12px 16px",
                      marginTop: 4,
                    }} elevation={0}>
                      {tripData.notes?.split("\\n").map((item, key) => (
                        <span key={key} style={{ fontSize: "var(--font-size-sm)", lineHeight: 1.5, display: "block" }}>
                          {item}
                        </span>
                      ))}
                    </Paper>
                  )}
                </Grid>

                {/* Ticket & tonnage info */}
                <Grid item xs={6}>
                  <Paper className={classes.headerpickup} elevation={0} style={{ marginTop: 4 }}>
                    <Typography variant='body2' className={classes.text}>
                      {tripData.ticketShipperNumber && tripData.ticketShipperNumber.trim()
                        ? tripData.ticketShipperNumber
                        : "Ticket #..."}
                    </Typography>
                  </Paper>
                  <Paper className={classes.headerpickup} elevation={0} style={{ marginTop: 4 }}>
                    <Typography variant='body2' className={classes.text}>
                      {tripData.shipperTons > 0 ? tripData.shipperTons : `${text("Tonnage")}...`}
                    </Typography>
                  </Paper>
                  <div style={{ height: 8 }} />
                  <Paper
                    className={classes.headerpickup}
                    elevation={0}
                    onClick={() => onTtime_in(1)}
                    style={{ cursor: "pointer", marginTop: 4 }}
                  >
                    <Typography variant='body2' className={classes.text}>
                      {tripData.shipperIn !== null
                        ? moment.utc(tripData.shipperIn).format("HH:mm:ss")
                        : text("Check in time")}
                    </Typography>
                  </Paper>
                  <Paper
                    className={classes.headerpickup}
                    elevation={0}
                    onClick={() => onTtime_in(3)}
                    style={{ cursor: "pointer", marginTop: 4 }}
                  >
                    <Typography variant='body2' className={classes.text}>
                      {tripData.shipperOut !== null
                        ? moment.utc(tripData.shipperOut).format("HH:mm:ss")
                        : text("Departure time")}
                    </Typography>
                  </Paper>
                </Grid>

                <Grid item xs={6}>
                  <Paper className={classes.headerdelivery} elevation={0} style={{ marginTop: 4 }}>
                    <Typography variant='body2' className={classes.text}>
                      {tripData.ticketConsigneeNumber && tripData.ticketConsigneeNumber.trim()
                        ? tripData.ticketConsigneeNumber
                        : "Ticket #..."}
                    </Typography>
                  </Paper>
                  <Paper className={classes.headerdelivery} elevation={0} style={{ marginTop: 4 }}>
                    <Typography variant='body2' className={classes.text}>
                      {tripData.consigneeTons > 0 ? tripData.consigneeTons : `${text("Tonnage")}...`}
                    </Typography>
                  </Paper>
                  <div style={{ height: 8 }} />
                  <Paper
                    className={classes.headerdelivery}
                    elevation={0}
                    onClick={() => onTtime_in(2)}
                    style={{ cursor: "pointer", marginTop: 4 }}
                  >
                    <Typography variant='body2' className={classes.text}>
                      {tripData.consigneeIn !== null
                        ? moment.utc(tripData.consigneeIn).format("HH:mm:ss")
                        : text("Check in time")}
                    </Typography>
                  </Paper>
                  <Paper className={classes.headerdelivery} elevation={0} style={{ marginTop: 4 }}>
                    <Typography variant='body2' className={classes.text}>
                      {tripData.consigneeOut !== null
                        ? moment.utc(tripData.consigneeOut).format("HH:mm:ss")
                        : text("Departure time")}
                    </Typography>
                  </Paper>
                </Grid>

                <Grid item xs={12}>
                  <div style={{ height: 4 }} />
                </Grid>

                {/* Upload/View Ticket */}
                <Grid item xs={12}>
                  <input
                    type='file'
                    capture='camera'
                    accept='image/*'
                    id='icon-button-file'
                    name='uploadPhotoInput'
                    hidden
                    onChange={onFileChange}
                    onClick={(event) => {
                      event.target.value = null;
                    }}
                  />
                  <Paper
                    elevation={0}
                    onClick={() => handleTicketpickup(2)}
                    style={{
                      cursor: "pointer",
                      borderRadius: 12,
                      overflow: "hidden",
                    }}
                  >
                    <Typography
                      variant='body1'
                      className={
                        tripData.locationToUrlFile !== null
                          ? classes.viewTicket
                          : classes.textButton
                      }
                    >
                      {tripData.locationToUrlFile !== null
                        ? text("View Ticket")
                        : text("Upload Ticket")}
                    </Typography>
                  </Paper>
                </Grid>

                {/* QR Codes */}
                <Grid item xs={6}>
                  <Paper
                    elevation={0}
                    style={{
                      height: 90,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 12,
                      backgroundColor: "#fafafa",
                    }}
                  >
                    <SvgIcon
                      component={QRCode}
                      viewBox='0 0 1000 1000'
                      style={{ width: "80%", height: "80%" }}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <Paper
                    elevation={0}
                    style={{
                      height: 90,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 12,
                      backgroundColor: "#fafafa",
                    }}
                  >
                    <SvgIcon
                      component={QRCode}
                      viewBox='0 0 1000 1000'
                      style={{ width: "80%", height: "80%" }}
                    />
                  </Paper>
                </Grid>
              </Grid>
            </div>

            <Alert
              isOpen={errorSnackbar.isOpen}
              handleClose={handleClose}
              text={text(errorSnackbar.message)}
            />

            <DialogCrop
              imageDataUrl={imageDataUrl}
              isOpen={isOpen}
              handleClose={handleCloseDialog}
              load={tripData}
              typeload={typeload}
            />
            <DialogTrips
              open={openQuestionDialog}
              onClose={onCloseDestinationWrong}
              title={text("Warning")}
              question={text("Report wrong destination?")}
              load_id={tripData.load_id}
              type={typeload}
              dispatch={dispatch}
              fetchRequest={fetchRequest}
            />
            <CustomDialog
              isOpen={pdfDialog}
              handleClose={handleClosePdfDialog}
              title='Pdf Ticket'
              childrenElement={
                <Pdf
                  handleClose={handleClosePdfDialog}
                  data={{ url: pdfName }}
                />
              }
              showCancelButton={true}
            />
          </div>
        );
      }
    } else {
      return (
        <div className="loads_empty">
          <i className="material-icons">local_shipping</i>
          <Typography variant='subtitle1' style={{ fontWeight: 500, marginTop: 8 }}>
            {text("Has no trips")}
          </Typography>
        </div>
      );
    }
  } else {
    return "";
  }
}
